module.exports = __webpack_public_path__ + "static/other/gamePaint.3fcaf9f8.json";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/atlas/gamePaint.json
// module id = 2317
// module chunks = 0